import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

const Page = ({ title, children }) => (
  <div className="min-h-screen bg-[#0A0908] text-[#F5F0E6]">
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-12">
      <Link to="/" className="inline-flex items-center gap-1 text-sm text-[#F5F0E6]/60 hover:text-[#C89B3C] mb-6">
        <ChevronLeft size={16} /> Volver
      </Link>
      <p className="text-[11px] uppercase tracking-[0.4em] text-[#C89B3C] mb-2">El Navegante Wester</p>
      <h1 className="text-4xl md:text-5xl mb-8" style={{ fontFamily: "'Playfair Display'", fontWeight: 700 }}>{title}</h1>
      <div className="prose prose-invert max-w-none space-y-4 text-[#F5F0E6]/85 leading-relaxed">
        {children}
      </div>
    </div>
  </div>
);

export const AboutPage = () => (
  <Page title="Nosotros">
    <p>El Navegante Wester nació en Hollister, California, como refugio para quienes viven el estilo vaquero con autenticidad.</p>
    <p>Trabajamos solo con marcas y artesanos que respetan la talabartería tradicional: cuero de verdad, costuras hechas a mano, piezas que duran generaciones.</p>
    <p>Nuestra tienda está en el corazón de la ciudad — un lugar donde el aroma del cuero y los sombreros nuevos te recuerda por qué este estilo nunca pasa de moda.</p>
    <h3 className="text-2xl text-[#C89B3C] mt-6" style={{ fontFamily: "'Playfair Display'" }}>Visítanos</h3>
    <p>1270 Fourth Street Ste F · Hollister, CA 95023<br />Lun–Sáb 10:00 AM – 8:00 PM · Dom 10:00 AM – 6:00 PM</p>
  </Page>
);

export const ShippingPage = () => (
  <Page title="Envíos">
    <p><strong className="text-[#C89B3C]">Envío estándar:</strong> $15 USD a cualquier punto en Estados Unidos continental. 3 a 7 días hábiles.</p>
    <p><strong className="text-[#C89B3C]">Envío GRATIS</strong> en pedidos sobre $150 USD.</p>
    <p><strong className="text-[#C89B3C]">Pickup en tienda:</strong> gratis en 1270 Fourth St, Hollister CA. Te avisamos por correo cuando esté listo (normalmente el mismo día).</p>
    <p>Enviamos todos los pedidos en 1-2 días hábiles. Recibirás un correo con el número de tracking.</p>
  </Page>
);

export const ReturnsPage = () => (
  <Page title="Devoluciones">
    <p>Tienes <strong className="text-[#C89B3C]">15 días</strong> desde la entrega para devolver cualquier producto que no te quede o no te convenza.</p>
    <p>La prenda debe estar sin usar, con sus etiquetas originales y en condición de venta. Las botas deben traer la caja original.</p>
    <p>Las personalizaciones (grabados, tallas especiales) no tienen devolución.</p>
    <h3 className="text-2xl text-[#C89B3C] mt-6" style={{ fontFamily: "'Playfair Display'" }}>¿Cómo devolver?</h3>
    <ol className="list-decimal pl-6 space-y-2">
      <li>Llámanos o escríbenos para generar el folio de devolución.</li>
      <li>Empaca el producto con la etiqueta de devolución.</li>
      <li>Reembolsamos a tu forma de pago original en 5-7 días una vez recibido.</li>
    </ol>
  </Page>
);
